import React from 'react';
import { Link } from 'react-router-dom';
import { LibraryIcon } from 'lucide-react';
import { CatalogRow } from '../components/CatalogRow';
import { EmptyState } from '../components/EmptyState';
import { useCatalog } from '../contexts/CatalogContext';
import { slugify } from '../utils/production';
import { buttonClass, pagePadding } from '../utils/styles';
export function Collections() {
  const {
    published
  } = useCatalog();
  const names = Array.from(new Set(published.map(p => p.collection).filter((c): c is string => !!c)));
  const groups = [{
    id: 'originals',
    title: 'NICOLE Originals',
    items: published.filter(p => p.isOriginal)
  }, ...names.map(name => ({
    id: `coleccion-${slugify(name)}`,
    title: name,
    items: published.filter(p => p.collection === name)
  }))].filter(g => g.items.length > 0);
  return <div className="pb-24 pt-28 md:pt-32" data-id="element-395" data-mp="muf8axlgjhlv">
      <header className={`max-w-3xl ${pagePadding}`} data-id="element-396" data-mp="rn8i3zvs9g4t">
        <h1 className="font-display text-4xl font-black uppercase tracking-tight md:text-6xl" data-id="element-397" data-mp="rotbhm6d2t13">Colecciones</h1>
        <p className="mt-4 text-base text-mist md:text-lg" data-id="element-398" data-mp="9gsb8ikby6wa">Las obras de Nicole agrupadas por universo, serie o temática.</p>
      </header>

      {groups.length === 0 ? <EmptyState icon={LibraryIcon} title="Todavía no hay colecciones" description="Las colecciones aparecerán aquí cuando se publiquen obras agrupadas." action={<Link to="/" className={buttonClass('secondary', 'md')} data-id="element-400" data-mp="x8fpo10enpho">
              Volver al inicio
            </Link>} data-id="element-399" data-mp="o6zl49w9uhld" /> : <div className="mt-12 space-y-10" data-id="element-401" data-mp="173hhx5pz97oh">
          {groups.map(g => <CatalogRow key={g.id} id={g.id} title={g.title} productions={g.items} emptyMessage="" data-id="element-402" data-mp="125phtof6if97" />)}
        </div>}
    </div>;
}